import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';

import { TyreOrderSearchModel } from '../../models/tyre-order/tyre-orderSearch';
import * as OrderStatusModels from '../../models/order/orderStatus';
import { EnvironmentService } from '../../../app/services/environment.service';
import * as TyreOrderModels from '../../models/tyre-order/tyre-order';
import * as Models from '../../models/commonModels';

@Injectable({
  providedIn: 'root'
})

export class TyreOrderService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  public getList(Search: TyreOrderSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    return this.httpClient.post<TyreOrderModels.TyreOrderListModel>(`${this.environmentService.getApiURL()}/tyre-order/list`, Search, options);
  }

  public getStatusDictionary() {
    return this.httpClient.get<OrderStatusModels.OrderStatusListModel>(`${this.environmentService.getApiURL()}/tyre-order/status`);
  }

  public create(TyreOrder: Models.Request<TyreOrderModels.TyreOrderCreateModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<TyreOrderModels.TyreOrderObjectModel>(`${this.environmentService.getApiURL()}/tyre-order/create`, TyreOrder, options);
  }

  public set(TyreOrder: Models.Request<TyreOrderModels.TyreOrderModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<TyreOrderModels.TyreOrderObjectModel>(`${this.environmentService.getApiURL()}/tyre-order/set`, TyreOrder, options);
  }

  public get(TyreOrder: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<TyreOrderModels.TyreOrderObjectModel>(`${this.environmentService.getApiURL()}/tyre-order/get`, TyreOrder, options);
  }

  public uploadFile(Data: any) {

    const httpHeaders = new HttpHeaders()
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' };

    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/tyre-order/import-order`, Data, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }

  public getFilteredReport(Search: TyreOrderSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };
    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/tyre-order/report/filtered`, Search, options);
  }

  public ImportLatexDeliveryFile(ImportFile: File) {

    const httpHeaders = new HttpHeaders()
      .set('Cache-Control', 'no-cache');

    const formData: FormData = new FormData();
    formData.append('fileKey', ImportFile, ImportFile.name);

    const options = { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' };

    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/tyre-order/import-latex-delivery`, formData, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }
}
